import { Button, Card, Col, Row, Typography, Image, Layout,Modal } from 'antd';
import React from 'react';
import { useState } from 'react';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import ContactForm from '../../utils/contactform';

const { Title, Text, Paragraph } = Typography;
const { Content, Footer } = Layout;

const SellPropertyPage = () => {
  const [showForm, setShowForm] = useState(false);
  return (
    <Layout style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      <Content style={{
        flex: 1,
        padding: '24px',
        maxWidth: '1200px',
        width: '100%',
        margin: '0 auto',
        overflow: 'hidden'
      }}>
        {/* Hero Section */}
        <Row gutter={[24, 24]} align="middle" style={{ marginBottom: '48px' }}>
          <Col xs={24} md={16}>
            <Title level={1} style={{ fontWeight: 'bold', marginBottom: '24px' }}>
              Maximize Your Property's Value with Trinest
            </Title>
            <Paragraph style={{ fontSize: '16px', marginBottom: '24px' }}>
              Looking to sell your property in Dubai or rent it out for consistent income? At Trinest Sky Real Estate, 
              we offer end-to-end services to help homeowners and landlords navigate Dubai's competitive real estate 
              market with confidence. Whether you're a local property owner or an overseas investor, our experienced 
              team ensures your property reaches the right audience and achieves the best possible return.
            </Paragraph>
            
            <Button type="btn btn-yellow" size="large" style={{ marginTop: '12px' }}
             onClick={() => setShowForm(true)}
            >
              List Your Property
            </Button>
            {showForm && <ContactForm />}
            <Modal
                title="List Your Property"
                open={showForm}
                onCancel={() => setShowForm(false)}
                footer={null}
                centered
                width={500}
                bodyStyle={{
                    height: 500,
                    overflowY: "auto",
                    padding: "20px"
                }}
            >
                <ContactForm onClose={() => setShowForm(false)} />
            </Modal>
          </Col>
          <Col xs={24} md={8}>
            <Image
              src="assets/img/team/6 (1).png"
              alt="Dubai Property"
              style={{ borderRadius: '8px', boxShadow: '0 4px 8px rgba(0,0,0,0.1)' }}
              preview={false}
            />
          </Col>
        </Row>

        {/* Why Choose Us Section */}
        <div style={{ marginBottom: '48px', padding: '24px', backgroundColor: '#f5f5f5', borderRadius: '8px' }}>
          <Title level={2} style={{ textAlign: 'center', marginBottom: '48px' }}>
            Why Sell or Rent with Trinest Sky?
          </Title>
          <Row gutter={[24, 24]}>
            {[
              {
                title: " Free Property Valuation",
                content: "Get an accurate, market-driven valuation for your apartment, villa, or commercial space."
              },
              {
                title: " Expert Marketing & Listing",
                content: "We list your property on top portals (Property Finder, Bayut, Dubizzle, etc.) and promote it via social media, Google Ads, and email campaigns."
              },
              {
                title: " Large Buyer & Tenant Network",
                content: "We have a verified database of ready buyers and tenants looking for properties across Dubai."
              },
              {
                title: " Professional Photography & Videography",
                content: "High-quality visuals make your listing stand out in the crowded Dubai property market."
              },
              {
                title: " RERA-Certified Agents",
                content: "Our team ensures legal compliance, documentation, and negotiation support from start to finish."
              }
            ].map((item, index) => (
              <Col key={index} xs={24} md={index < 3 ? 8 : 12}>
                <Card style={{ height: '100%', border: 'none', boxShadow: '0 1px 2px rgba(0,0,0,0.1)' }}>
                  <Title level={5} style={{ color: '#fda94f' }}>{item.title}</Title>
                  <Text>{item.content}</Text>
                </Card>
              </Col>
            ))}
          </Row>
           
        </div>

        {/* Sell Property Section */}
        <div style={{ marginBottom: '48px' }}>
          <Title level={2} style={{ marginBottom: '24px' }}>Sell Your Property in Dubai</Title>
          <Paragraph style={{ fontSize: '16px', marginBottom: '24px' }}>
            Thinking of upgrading, liquidating your asset, or moving abroad? We specialize in selling:
          </Paragraph>
          <Row gutter={[24, 24]}>
            <Col xs={24} md={12}>
              <ul style={{  padding: 0 }}>
                <li style={{ marginBottom: '8px' }}> Apartments in Downtown Dubai, Dubai Marina, JVC, and more</li>
                <li style={{ marginBottom: '8px' }}> Villas in Arabian Ranches, DAMAC Hills, The Springs, and similar communities</li>
              </ul>
            </Col>
            <Col xs={24} md={12}>
              <ul style={{  padding: 0 }}>
                <li style={{ marginBottom: '8px' }}> Off-plan properties with attractive resale value</li>
                <li style={{ marginBottom: '8px' }}> Commercial units and investment properties</li>
              </ul>
            </Col>
          </Row>
          <div style={{ backgroundColor: '#fda94f', color: 'white', padding: '16px', borderRadius: '8px', marginTop: '24px' }}>
            <Title level={4} style={{ color: 'white', marginBottom: 0 }}>
              We'll help you set the right asking price, create compelling listings, and negotiate the best offer with full transparency.
            </Title>
          </div>
        </div>

        {/* Rent Property Section */}
        <div style={{ marginBottom: '48px' }}>
          <Title level={2} style={{ marginBottom: '24px' }}>Rent Out Your Property in Dubai</Title>
          <Paragraph style={{ fontSize: '16px', marginBottom: '24px' }}>
            Want to earn passive income? Renting out your Dubai property is a smart option with strong demand from residents and expats. 
            We assist you with:
          </Paragraph>
          <Row gutter={[24, 24]}>
            <Col xs={24} md={12}>
              <ul style={{ padding: 0 }}>
                <li style={{ marginBottom: '8px' }}> Long-term and short-term leasing options</li>
                <li style={{ marginBottom: '8px' }}> Tenant screening and background checks</li>
              </ul>
            </Col>
            <Col xs={24} md={12}>
              <ul style={{padding: 0 }}>
                <li style={{ marginBottom: '8px' }}> Tenancy contract management</li>
                <li style={{ marginBottom: '8px' }}> Property handover and inspection services</li>
              </ul>
            </Col>
          </Row>
          <div style={{ backgroundColor: '#f5f5f5', padding: '16px', borderRadius: '8px', marginTop: '24px' }}>
            <Paragraph style={{ marginBottom: 0 }}>
              Stay stress-free while we handle everything—from listing to leasing and even property management if needed.
            </Paragraph>
          </div>
        
        </div>

      </Content>
      
    </Layout>
  );
};

export default SellPropertyPage;
